import {CONFIGURATION_INITIALIZER} from "../../../initializers/ActiveBrandInitializer";

class MaterialThemingProvider {
    constructor($mdThemingProvider) {
        // let mainColor = applicationConfigurations.mainColor;
        // let sideColor = applicationConfigurations.sideColor;
        let theme = process.env.THEME ? process.env.THEME : "default-dark"
        let principle = CONFIGURATION_INITIALIZER.assertResolvedAndGetPrinciple();
        let mainColor = principle.mainHeaderColor ? principle.mainHeaderColor : 'indigo';
        let sideHeaderColor = principle.sideHeaderColor ? principle.sideHeaderColor : 'blue';
        $mdThemingProvider.theme(theme, 'default')
            .primaryPalette(mainColor,
                {
                    'hue-1': '500',
                    'hue-2': '700',
                    'hue-3': '800'
                })
            .accentPalette(sideHeaderColor,
                {
                    'hue-1': '100',
                    'hue-2': '200',
                    'hue-3': '400'
                })
            .dark();

        $mdThemingProvider.theme('default', 'default')
            .primaryPalette(mainColor,
                {
                    'hue-1': '500',
                    'hue-2': '700',
                    'hue-3': '800'
                })
            .accentPalette(sideHeaderColor,
                {
                    'hue-1': '200',
                    'hue-2': '400',
                    'hue-3': '600'
                });
        $mdThemingProvider.setDefaultTheme('default');

    }
}

export const MATERIAL_THEMMING_PROVIDER = ['$mdThemingProvider', MaterialThemingProvider];